import { LandingPagesNavbar } from '@podus/ui';
import { resolveProductUrl } from '@podus/utils';

export function Navbar() {
    return (
        <div className="w-full">
            <LandingPagesNavbar homeHref={resolveProductUrl('https://podus.org')} helpHref="/" />
        </div>
    );
}
